import { Glyph } from "./icons";
import { Tooltip } from "./Tooltip";

/** Optional explanation only; decisions, errors and recovery instructions stay inline. */
export function HelpTooltip({ label, children, icon, text }: { label: string; children: string; icon?: string; text?: string }) {
  return <Tooltip content={children} openOnClick><button type="button" className={`help-trigger${text ? " is-text" : ""}`} aria-label={`About ${text ?? label}`}>
    {text != null ? <span aria-hidden="true">{text}</span> : icon ? <Glyph name={icon} /> : <span aria-hidden="true">?</span>}
  </button></Tooltip>;
}
